// src/db/index.js
import Dexie from 'dexie';

// Create the Dexie instance for both taketraining and pretest in the same file

// Define the taketraining database
export const taketrainingDb = new Dexie('taketraining');
taketrainingDb.version(1).stores({
  trainings: '++id, training_id, user_id, status', // Define the table schema for taketraining
});

export const modalTriggeredDB = new Dexie('modalTriggered');
modalTriggeredDB.version(1).stores({
  modalTriggered: '++id, dashboard, trainings'
});

// Define the pretest database
export const pretestDb = new Dexie('pretest');
pretestDb.version(1).stores({
  pretests: '++id, test_id, user_id, training_id, status, exam_type', // Define the main fields
  data: '&[training_id+exam_type], question_id', // Store detailed pretest question/answer data
});

export const quizDb = new Dexie('quiz');
quizDb.version(1).stores({
  quiz: '++id, test_id, user_id, training_id, status, exam_type',
  data: '&[training_id+exam_type], question_id',
});

export const postEvalDb = new Dexie('postEvaluation');
postEvalDb.version(1).stores({
    evaluations: '++id, user_id, training_id, status, exam_type',
    data: '&[training_id+exam_type], question_id', 
});

export const checktrainingsDb = new Dexie('checktrainings');
checktrainingsDb.version(1).stores({
  checktrainings: '++id, training_id, exam_type, progress_status',  // Define the primary key and indexed fields
});

export const updatedProgDb = new Dexie('updatedProgDb');
updatedProgDb.version(1).stores({
  updatedProg: '++id, training_id, pretest, vl, quiz, posteval',  // Define the primary key and indexed fields
});